import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
    scrollBehavior(to, from, savedPosition) {
        const fromIsRoot = from.path === '/';
        const toIsRoot = to.path === '/';
        const fromIsWork = from.path.startsWith('/work');
        const toIsWork = to.path.startsWith('/work');

        const keepScroll = (fromIsRoot && toIsWork) || (fromIsWork && toIsRoot);
        if (keepScroll) return savedPosition;

        return { top: 0 };
    }
};
